const { MeasurementType } = require('@/models');
const { baseTimeFields, createdTimeField } = require('@/classes/timeFields');

module.exports = {
    routes: [
        {
            path: '/measurements/types',
            name: 'measurementTypes',
            meta: {
                permissions: ['measurementtypes.read']
            },
            component: () => import('./types/index.vue')
        },
        {
            path: '/measurements/types/detail/:id?',
            name: 'measurementType',
            meta: {
                permissions: ['measurementtypes.update', 'measurementtypes.create']
            },
            component: () => import('./types/detail.vue')
        }],
    types: {
        itemObject: MeasurementType,
        search: MeasurementType.searchConfig,
        defaultTimeField: 'createdAt',
        timeFields: baseTimeFields,
        index: {
            route: 'measurementTypes',
            endpoint: 'measurementTypes',
            fields: ['id', 'name', 'icon', 'unit{id name}', 'productTypes{id name}', 'createdAt', 'updatedAt'],
            headers: [
                {
                    text: 'Icoon',
                    value: 'icon',
                    width: 30,
                    sortable: false,
                    component: () => import('./../../components/columns/eod-column-icon.vue')
                },
                {
                    text: 'Eenheid',
                    value: 'unit.name',
                    width: 30,
                    sortable: false,
                    component: () => import('./../../components/columns/eod-column-link.vue')
                },
                {
                    text: 'Naam',
                    value: 'name',
                    component: () => import('./../../components/columns/eod-column-link.vue')
                },
                {
                    text: 'Asset types',
                    value: 'productTypes',
                    sortable: false,
                    component: () => import('./../../components/columns/eod-column-tags.vue')
                },
                {
                    text: 'Aanmaakdatum',
                    width: 50,
                    value: 'createdAt',
                    component: () => import('./../../components/columns/eod-column-date.vue'),
                    extra: {
                        icon: 'mdi-alarm-plus',
                        collapsed: true,
                        prepend: 'Aangemaakt op'
                    }
                }, {
                    text: 'Aanpassingsdatum',
                    width: 50,
                    value: 'updatedAt',
                    component: () => import('./../../components/columns/eod-column-date.vue'),
                    extra: {
                        icon: 'mdi-alarm',
                        collapsed: true,
                        prepend: 'Gewijzigd op'
                    }
                }, {
                    width: 120,
                    sortable: false,
                    value: 'actions',
                    draggable: false,
                    component: () => import('./../../components/columns/eod-column-actions.vue')
                }
            ],
            tabs: [{
                path: 'measurementTypes',
                text: 'Types'
            }],
        },
        detail: {
            route: 'measurementType',
            endpoint: 'measurementType',
            objectName: 'MeasurementType',
            // De bewaarde lijst (met de door de backend toegekende id's) mee terugvragen,
            // zodat een tweede save de lijst/items bijwerkt i.p.v. duplicaten aan te maken.
            saveOptions: {
                create: {
                    returnfields: ['id', 'valueConfigList{id name description itemType fields{name description isActive} listItems{id name description low high threshold stepSize color fields{name description isActive}}}']
                },
                update: {
                    returnfields: ['id', 'valueConfigList{id name description itemType fields{name description isActive} listItems{id name description low high threshold stepSize color fields{name description isActive}}}']
                }
            },
            fields: ['id', 'name', 'description', 'color', 'productTypes{id name settings{id starttime endtime value}}', 'icon', 'unit{id}', 'typeConfig', 'isWritable', 'field', 'metricConfig{hardwareId dataType factor offset interval method}', 'sourceMeasurementType{id name}', 'settingMeasurementType{id name}', 'factor', 'valueConfigList{id measurementTypes{id} name description itemType fields{name description isActive} listItems{id name description low high threshold stepSize color fields{name description isActive}}}', 'dashboardConfig', 'formConfig{enabled columns required photo photoRequired photoMax comment commentRequired type category subCategory defaultValue values}'],
            tabs: [],
        },
        export: {
            endpoint: 'measurementTypes',
            fields: ['id', 'name', 'description']
        },
        import: {
            endpoint: 'MeasurementTypes',
            objectName: 'MeasurementType',
        },
    }
}